import React from 'react';

interface Brand {
  name: string;
  logo: string;
}

const BrandLogos: React.FC = () => {
  const brands: Brand[] = [
    { name: 'Brand 1', logo: '/logos/Image (2).png' },
    { name: 'Brand 2', logo: '/logos/Image (4).png' },
    { name: 'Brand 3', logo: '/logos/Image (5).png' },
    { name: 'Brand 4', logo: '/logos/Image (6).png' },
    { name: 'Brand 5', logo: '/logos/Image (7).png' },
    { name: 'Brand 6', logo: '/logos/Image (8).png' },
    { name: 'Brand 7', logo: '/logos/Image (9).png' }
  ];

  // Dupliquer les logos pour créer un effet de boucle infinie
  const duplicatedBrands = [...brands, ...brands, ...brands];

  return (
    <section className="py-5 md:py-7 bg-white border-t border-b border-gray-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Logos Scrolling Container */}
        <div className="relative">
          <style>{`
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-33.333%);
              }
            }
            
            .scroll-container {
              animation: scroll 30s linear infinite;
            }
            
            .scroll-container:hover {
              animation-play-state: paused;
            }
          `}</style>
          
          <div className="scroll-container flex items-center gap-12 md:gap-16">
            {duplicatedBrands.map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 flex items-center justify-center transition-all duration-300 hover:scale-110 min-w-[150px] h-20"
              >
                <img 
                  src={brand.logo} 
                  alt={brand.name}
                  className="max-h-full max-w-[200px] w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;

